<template>
  <span v-if="workingReward">
    <v-row class="mt-8">
      <v-col cols="12">
        <v-text-field
          label="Reduction Amount"
          v-model="workingReward.feeReductionAmount"
          type="number"
          hint="Ex. 5.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="feeReductionAmount"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { EstatementFeeReductionReward } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class EstatementFeeReductionRewardEditor extends Vue {
  @Prop()
  value!:EstatementFeeReductionReward;

  workingReward:EstatementFeeReductionReward | null = null;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as EstatementFeeReductionReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
</script>

<style lang="scss" scoped>
</style>
